import { Grid, Typography } from '@mui/material'
import React, { useState } from 'react'
import useStyles from './useStyles'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CancelIcon from '@mui/icons-material/Cancel'
import SyncIcon from '@mui/icons-material/Sync'
import { ModalChangeAdminME } from '../../../../components/Modals/Organizations/User/ModalChangeAdminME/ChangeAdminME'

export const UsersDetails = ({ dataprocess = null }) => {
  const classes = useStyles()
  const [modalChangeUserAdmin, setModalChangeUserAdmin] = useState(false)
  const [userId, setuserId] = useState(null)

  return (
    <>
      <Grid container className={classes.boxDetails}>
        <Grid item xs={12}>
          <Typography
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              color: '#4B4952',
              paddingLeft: 10,
              borderBottom: '1px solid rgba(36, 55, 143, 0.2)'
            }}
          >
            Estado de los usuarios administradores
          </Typography>
        </Grid>
        {dataprocess &&
          dataprocess.data?.users?.length > 0 &&
          dataprocess.data.users.map((user) => (
            <>
              <Grid item xs={9}>
                <Grid container style={{ padding: 10 }} key={user.userId}>
                  <Grid item xs={6}>
                    <Typography
                      style={{
                        fontSize: 14,
                        fontWeight: 'bold',
                        color: '#485450'
                      }}
                    >
                      Nombre y Apellido:
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      style={{
                        fontSize: 14,
                        fontWeight: 'bold',
                        color: '#4B4952'
                      }}
                    >
                      {user.firstName + ' ' + user.lastName}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container style={{ padding: 10 }}>
                  <Grid item xs={6}>
                    <Typography
                      style={{
                        fontSize: 14,
                        fontWeight: 'bold',
                        color: '#485450'
                      }}
                    >
                      Correo electrónico:
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      style={{
                        fontSize: 14,
                        fontWeight: 'bold',
                        color: '#4B4952'
                      }}
                    >
                      {user.email || 'No encontrado'}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container style={{ padding: 10 }}>
                  <Grid item xs={6}>
                    <Typography
                      style={{
                        fontSize: 14,
                        fontWeight: 'bold',
                        color: '#485450'
                      }}
                    >
                      Número de usuario:
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      style={{
                        fontSize: 14,
                        fontWeight: 'bold',
                        color: '#4B4952'
                      }}
                    >
                      {user.legacyUserRefId || 'No encontrado'}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container style={{ padding: 10 }}>
                  <Grid item xs={6}>
                    <Typography
                      style={{
                        fontSize: 14,
                        fontWeight: 'bold',
                        color: '#485450'
                      }}
                    >
                      Estado activo:
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    {user.isActive
                      ? (
                      <CheckCircleIcon
                        style={{ fontSize: '2rem', color: '#00a78f' }}
                      />
                        )
                      : (
                      <CancelIcon
                        style={{ fontSize: '2rem', color: '#AD0707' }}
                      />
                        )}
                  </Grid>
                </Grid>
                <Grid container style={{ padding: 10 }}>
                  <Grid item xs={6}>
                    <Typography
                      style={{
                        fontSize: 14,
                        fontWeight: 'bold',
                        color: '#485450'
                      }}
                    >
                      Pertenece al Staff:
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    {user.suborganizationStaffExits
                      ? (
                      <CheckCircleIcon
                        style={{ fontSize: '2rem', color: '#00a78f' }}
                      />
                        )
                      : (
                      <CancelIcon
                        style={{ fontSize: '2rem', color: '#AD0707' }}
                      />
                        )}
                  </Grid>
                </Grid>
                <Grid container style={{ padding: 10 }}>
                  <Grid item xs={6}>
                    <Typography
                      style={{
                        fontSize: 14,
                        fontWeight: 'bold',
                        color: '#485450'
                      }}
                    >
                      Existe en Mi Errepar:
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    {user.userExist
                      ? (
                      <CheckCircleIcon
                        style={{ fontSize: '2rem', color: '#00a78f' }}
                      />
                        )
                      : (
                      <CancelIcon
                        style={{ fontSize: '2rem', color: '#AD0707' }}
                      />
                        )}
                  </Grid>
                </Grid>
                <Grid container style={{ padding: 10 }}>
                  <Grid item xs={6}>
                    <Typography
                      style={{
                        fontSize: 14,
                        fontWeight: 'bold',
                        color: '#485450'
                      }}
                    >
                      Estado de acceso:
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    {user.userstatusAccessMEExist
                      ? (
                      <CheckCircleIcon
                        style={{ fontSize: '2rem', color: '#00a78f' }}
                      />
                        )
                      : (
                      <CancelIcon
                        style={{ fontSize: '2rem', color: '#AD0707' }}
                      />
                        )}
                  </Grid>
                </Grid>
                <Grid container style={{ padding: 10 }}>
                  <Grid item xs={6}>
                    <Typography
                      style={{
                        fontSize: 14,
                        fontWeight: 'bold',
                        color: '#485450'
                      }}
                    >
                      Existe el rol:
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    {user.userGrantedRole
                      ? (
                      <CheckCircleIcon
                        style={{ fontSize: '2rem', color: '#00a78f' }}
                      />
                        )
                      : (
                      <CancelIcon
                        style={{ fontSize: '2rem', color: '#AD0707' }}
                      />
                        )}
                  </Grid>
                </Grid>
                <Grid
                  container
                  style={{
                    padding: 10,
                    borderBottom: '3px solid rgba(36, 55, 143, 0.2)'
                  }}
                >
                  <Grid item xs={6}>
                    <Typography
                      style={{
                        fontSize: 14,
                        fontWeight: 'bold',
                        color: '#485450'
                      }}
                    >
                      Existe la carpeta de sistema del usuario:
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    {user.userSystemDefinedDirStorageExist
                      ? (
                      <CheckCircleIcon
                        style={{ fontSize: '2rem', color: '#00a78f' }}
                      />
                        )
                      : (
                      <>
                        <CancelIcon
                          style={{ fontSize: '2rem', color: '#AD0707' }}
                        />
                      </>
                        )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={3}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  borderLeft: '2px solid rgba(36, 55, 143, 0.2)'
                }}
              >
                <div
                  style={{
                    display: 'inline-block',
                    color: '#00a78f',
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    setuserId(user.userId)
                    if (user.userId) setModalChangeUserAdmin(true)
                  }}
                >
                  <SyncIcon />
                  <Typography style={{ fontWeight: 'bold' }}>
                    Volver a configurar
                  </Typography>
                </div>
              </Grid>
            </>
          ))}
        <ModalChangeAdminME
          userId={userId}
          modalChangeUserAdmin={modalChangeUserAdmin}
          setModalChangeUserAdmin={setModalChangeUserAdmin}
        />
      </Grid>
    </>
  )
}
